const locale = {
    placeholder: 'Välj tid',
    rangePlaceholder: ['Starttid', 'Sluttid'],
};
export default locale;
